import { BankNames } from '@/constants';
import { handleError } from '@/services/handleError';
import { checkIsValidJSON } from '@/services/helpers/checkIsValidJSON';

import type { TAltynBankOffer } from '../../../types';
import type { IBaseBankOffer } from '../../../types/base-offer.types';

const getAltynInnerStateTitle = (
  sendedBody: string | null | undefined
): string | null => {
  if (!sendedBody || !checkIsValidJSON(sendedBody)) {
    return null;
  }
  try {
    const parsedBody = JSON.parse(sendedBody);
    return parsedBody.stateTitle || null;
  } catch (error) {
    handleError(error, { notify: false });
    return null;
  }
};

export const mapAltynOfferFromApi = (
  baseBankOffer: IBaseBankOffer
): TAltynBankOffer => {
  return {
    ...baseBankOffer,
    bankName: BankNames.altyn,
    altynInnerStateTitle: getAltynInnerStateTitle(baseBankOffer.bankDescription)
  };
};
